<template>
  <div class="mx-4 my-6 md:mx-8">
    <div v-if="!form.respondido">
      <h1 class="text-3xl">
        Como foi sua conversa com
        {{
          avaliacao && avaliacao.operador && avaliacao.operador.nome
            ? avaliacao.operador.nome
            : "o Operador"
        }}
        ?
      </h1>
      <p class="my-3">Um feedback honesto cria confiança.</p>
      <div class="grid grid-cols-12 gap-6 mt-6">
        <div class="col-span-12 md:col-span-5">
          <star-rating v-model="form.nota"></star-rating>
          <label for="obs" class="block text-sm font-medium mt-8">Observações</label>
          <textarea
            v-model="form.obs"
            rows="3"
            type="text"
            name="obs"
            id="obs"
            class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
          ></textarea>
          <button
            @click="save"
            type="button"
            class="inline-flex justify-center py-2 px-6 mt-5 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-500 hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:bg-green-400"
          >
            Enviar Avaliação
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <h1 class="text-3xl">Obrigado pela sua avaliação !</h1>
      <p class="my-3">Um feedback honesto cria confiança.</p>
      <button
        @click="form.respondido = false"
        type="button"
        class="inline-flex justify-center py-2 px-6 mt-5 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-gray-500 hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:bg-gray-400"
      >
        Responder novamente
      </button>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
export default {
  components: {
    StarRating,
  },
  data() {
    return {
      avaliacao: null,
      form: {
        nota: 0,
        obs: "",
        respondido: false,
      },
    };
  },
  methods: {
    async save() {
      if (this.form.nota === 0)
        return this.$vToastify.error("De uma nota para o atendimento!");

      this.form.respondido = true;
      this.form.user = this.$store.state.user;
      const req = await this.$http.put(`/operador/avaliacao`, this.form);

      if (req.data.success) {
        this.$vToastify.success("Salvo com sucesso!");
      } else {
        this.form.respondido = false;
        this.$vToastify.error(req.data.err);
      }
    },
    async start() {
      const id = this.$route.params.id;

      if (id) {
        const req = await this.$http.get(`/operador/avaliacao/${id}`);
        this.form._id = req.data._id;
        this.avaliacao = req.data;
        if (req.data.nota) this.form.nota = req.data.nota;
        if (req.data.obs) this.form.obs = req.data.obs;
        if (req.data.respondido) this.form.respondido = req.data.respondido;
      }
    },
  },
  async beforeMount() {
    this.start();
  },
};
</script>
